<template>
    <ul v-if="links" class="mobile-menu" >
        <li v-for="link in links" class="mobile-menu__item">
            <router-link
                :key="link.name"
                :to="link.route"
                class="mobile-menu__link"
            >
                <div class="mobile-menu__image">
                    <img class="mobile-menu__img" :src="'/static/mobile-menu/' + link.name + '.svg'" :alt="link.name">
                </div>
                <p class="mobile-menu__text">{{link.text | translate}}</p>
            </router-link>
        </li>
    </ul>
</template>

<script>
import Vue from 'vue';
import menuHelper from '../../../helpers/menu.helper'

export default {
    name: 'mobile-menu',
    data() {
        return {
            links: null
        };
    },
    async mounted() {
        this.links = await menuHelper.getMenuLinks();
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/mobile-menu/mobile-menu.vue